import React from 'react';
import packageJson from '../package.json';
global.appVersion = packageJson.version;

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);

  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());

    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

class CacheBuster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        console.log('Clearing cache and hard reloading...')
        if (caches) {
          // Service worker cache should be cleared with caches.delete()
          caches.keys().then(function(names) {
            for (let name of names) caches.delete(name);
          });
        }
        // alert('cache cleared, will reload the application...');
        // delete browser cache and hard reload


        const searchParams2 = new URLSearchParams(window.location.search);
        const version2 = searchParams2.get('v');

        if(version2){
          alert('The cache has been cleared. Please close this tab and open a new one with the URL:https://bullbreedingsoundness.com/');
        }else{
          window.location.reload(true);
        }


        // window.close();
      }
    };
  }

  componentDidMount() {
    fetch('/meta.json')
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version;
        const currentVersion = global.appVersion;
console.log('latest version')
console.log(latestVersion)

console.log('current version')
console.log(currentVersion)

const searchParams = new URLSearchParams(window.location.search);
const version = searchParams.get('v');
console.log(version);

// const shouldForceRefresh = version?true:false;
// console.log('shouldForceRefresh');
// console.log(shouldForceRefresh)

        const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion) || version;
        if (shouldForceRefresh) {
          console.log(`We have a new version - ${latestVersion}. Should force refresh`);
          this.setState({ loading: false, isLatestVersion: false });
        } else {
          console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
          this.setState({ loading: false, isLatestVersion: true });
        }
      });
  }
  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
    return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
  }
}

export default CacheBuster;
